import type { StaffSessionListDto } from '@icebreaker/shared/staff';
import { api, setAccessToken } from '@/shared/api/client';

/**
 * PERSONELİN KENDİ OTURUMLARI — `api` katmanı, YALNIZCA sagalardan çağrılır.
 *
 * Üç uç da `/panel/auth/sessions*` altındadır ve her personelin taban
 * yetkisiyle koşar (`staff:self_session_*`). Sunucu yalnız çağıranın
 * oturumlarını döner; başkasınınki 404'tür (IDOR sınırı sunucudadır).
 */

export async function fetchStaffSessions(): Promise<StaffSessionListDto> {
  return await api.staff.sessions();
}

export async function revokeStaffSession(sessionId: string): Promise<void> {
  await api.staff.revokeSession(sessionId);
}

/**
 * TÜMÜNÜ SONLANDIR — BU CİHAZ DAHİL. Sunucu çerezi de temizler; bellek jetonu
 * burada bırakılır, çünkü ondan sonra atılacak her istek zaten 401 alır.
 */
export async function revokeAllStaffSessions(): Promise<void> {
  try {
    await api.staff.revokeAllSessions();
  } finally {
    setAccessToken(null);
  }
}
